// 기업정보 선택 팝업

import React, {useContext, useEffect, useState} from "react";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { AppContext } from "../../RoundRegContext";
import { Trans, useTranslation } from "react-i18next";
import useAlert from "~/common/hooks/useAlert";

const CompanyInfoModal = ({ companyInfoModal, setCompanyInfoModal, setStep, isUpd }) => {
	const { t } = useTranslation();
	const [allCheck, setAllCheck] = useState(false);
	const [originalData, setOriginalData] = useState(null);
	const { inquiryDefaultInfo, setInquiryDefaultInfo, defaultModalSubmit } =
		useContext(AppContext);

	const [showAlert, Alert] = useAlert();

	const handleChange = (e) => {
		let temp = { ...inquiryDefaultInfo, [e.target.name]: e.target.checked };
		setInquiryDefaultInfo(temp);
		if(!e.target.checked) {
			setAllCheck(false);
		}
	};

	const allChange = (e) => {
		setInquiryDefaultInfo({
			...inquiryDefaultInfo,
			attach: e.target.checked, // 첨부파일
			nation: e.target.checked, // 국가
			stocks: e.target.checked, // 상장구분
		});
		setAllCheck(e.target.checked);
	};

	const handleSubmit = () => {
		defaultModalSubmit(isUpd);
		setCompanyInfoModal(false);
	};


	const handleCloseModal = () => {
		if(isUpd) {
			setInquiryDefaultInfo(originalData);
			setCompanyInfoModal(false);
		} else {
			showAlert().then(() => setStep("edit"));
		}
	}

	useEffect(() => {
		isUpd && setOriginalData(inquiryDefaultInfo)
	}, [isUpd]);

	useEffect(() => {
		(inquiryDefaultInfo?.nation && inquiryDefaultInfo?.attach && inquiryDefaultInfo?.stocks) && setAllCheck(true)
	}, [inquiryDefaultInfo])


	return (
		<ModalTemplate
			modalState={companyInfoModal}
			closeModal={handleCloseModal}
			title={
				<Trans
					i18nKey="pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.title"
					components={[<div />]}
				/>
			}
			width={450}
			height={410}
			className="company-infoChk-modal"
			closeable={false}
		>
			<div className="modal-content">
				<p className="modal-message">
					기업정보 선택
					<div className={"modal-message-text"}>기업 기본 요청 폼을 바로 작성하실 수 있습니다.</div>
				</p>
				<div className="checkbox-group">
					<div className="group">
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"companyName"}
									defaultValue={inquiryDefaultInfo.companyName}
									defaultChecked={inquiryDefaultInfo.companyName}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.companyName"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"businessNumber"}
									defaultValue={inquiryDefaultInfo.businessNumber}
									defaultChecked={inquiryDefaultInfo.businessNumber}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.businessNumber"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"ceo"}
									defaultValue={inquiryDefaultInfo.ceo}
									defaultChecked={inquiryDefaultInfo.ceo}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									대표자명
									{/*{t("pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.ceo")}*/}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"sales"}
									defaultValue={inquiryDefaultInfo.sales}
									defaultChecked={inquiryDefaultInfo.sales}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.sales"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"productDescription"}
									defaultValue={inquiryDefaultInfo.productDescription}
									defaultChecked={inquiryDefaultInfo.productDescription}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.productDescription"
									)}
								</span>
							</label>
						</div>
					</div>

					<div className="group">
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"establishment"}
									defaultValue={inquiryDefaultInfo.establishment}
									defaultChecked={inquiryDefaultInfo.establishment}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.establishment"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"employee"}
									defaultValue={inquiryDefaultInfo.employee}
									defaultChecked={inquiryDefaultInfo.employee}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.employee"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"companyType"}
									defaultValue={inquiryDefaultInfo.companyType}
									defaultChecked={inquiryDefaultInfo.companyType}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.companyType"
									)}
								</span>
							</label>
						</div>

						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"productName"}
									defaultValue={inquiryDefaultInfo.productName}
									defaultChecked={inquiryDefaultInfo.productName}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.productName"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"differentiation"}
									defaultValue={inquiryDefaultInfo.differentiation}
									defaultChecked={inquiryDefaultInfo.differentiation}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.differentiation"
									)}
								</span>
							</label>
						</div>

					</div>

					<div className="group">
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"address"}
									defaultValue={inquiryDefaultInfo.address}
									defaultChecked={inquiryDefaultInfo.address}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.address"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"homepage"}
									defaultValue={inquiryDefaultInfo.homepage}
									defaultChecked={inquiryDefaultInfo.homepage}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.homepage"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"description"}
									defaultValue={inquiryDefaultInfo.description}
									defaultChecked={inquiryDefaultInfo.description}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.description"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"industry"}
									defaultValue={inquiryDefaultInfo.industry}
									defaultChecked={inquiryDefaultInfo.industry}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.industry"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"keywords"}
									defaultValue={inquiryDefaultInfo.keywords}
									defaultChecked={inquiryDefaultInfo.keywords}
									disabled={true}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.keywords"
									)}
								</span>
							</label>
						</div>
					</div>
				</div>
				<p className="modal-message">
					선택 정보
					<div className={"modal-message-text"}>필요에 따라 선택하여 자료를 받으실 수 있습니다. </div>
				</p>
				<div className="checkbox-group">
					<div className="group flex-wrap">
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									checked={allCheck}
									value={allCheck}
									onChange={allChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t("pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.total")}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"attach"}
									value={inquiryDefaultInfo.attach}
									checked={allCheck || inquiryDefaultInfo.attach}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									첨부파일
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"nation"}
									value={inquiryDefaultInfo.nation}
									checked={allCheck || inquiryDefaultInfo.nation}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.nation"
									)}
								</span>
							</label>
						</div>
						<div className="checkbox">
							<label className="checkbox-custom">
								<input
									type="checkbox"
									name={"stocks"}
									value={inquiryDefaultInfo.stocks}
									checked={allCheck || inquiryDefaultInfo.stocks}
									onChange={handleChange}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">
									{t(
										"pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.stocks"
									)}
								</span>
							</label>
						</div>
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btn__solid" color="primary" onClick={handleSubmit}>
					{t("pages.round.RoundReg.Inquiry.modals.CompanyInfoModal.submit")}
				</button>
			</div>

			<Alert
				message={"질의 작성을 취소하시겠습니까?"}
				type="warning"
				reject={t("pages.vcInfo.VcMember.non")}
				confirm={t("pages.vcInfo.VcMember.yes")}
			/>

		</ModalTemplate>
	);
};

export default React.memo(CompanyInfoModal);
